import { BaseService } from "./BaseService";

export default class BillingService extends BaseService {

    async getbills(ticket: string){
        const params = {
          ticket
        }
        return this.submit(`bills`, "GET", undefined, params);
    }

    async postBillingInfo(payload: any) {
      return this.submit(`bill`, "POST", { bill: { ...payload } });
    }

}